export default __webpack_public_path__ + "static/media/image-square-2.46ba9070.jpg";